/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyRewardPrizeAwarded
 */
export interface MyRewardPrizeAwarded {
    /**
     * 
     * @type {string}
     * @memberof MyRewardPrizeAwarded
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof MyRewardPrizeAwarded
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MyRewardPrizeAwarded
     */
    currency?: string;
}

/**
 * Check if a given object implements the MyRewardPrizeAwarded interface.
 */
export function instanceOfMyRewardPrizeAwarded(value: object): value is MyRewardPrizeAwarded {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function MyRewardPrizeAwardedFromJSON(json: any): MyRewardPrizeAwarded {
    return MyRewardPrizeAwardedFromJSONTyped(json, false);
}

export function MyRewardPrizeAwardedFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyRewardPrizeAwarded {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'amount': json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function MyRewardPrizeAwardedToJSON(json: any): MyRewardPrizeAwarded {
    return MyRewardPrizeAwardedToJSONTyped(json, false);
}

export function MyRewardPrizeAwardedToJSONTyped(value?: MyRewardPrizeAwarded | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'currency': value['currency'],
    };
}

